(($) => {

    "use strict";

    $.enhancer("smoothScroll", function() {

        $(this).on("click", function(e) {
            const destination = $(this).attr("href");

            e.preventDefault();

            console.log(destination);

            $("html, body").animate({
                scrollTop: $(destination).offset().top-125
            }, 300);
        })
    });

})(jQuery);